import React, { useContext } from 'react';
import {
  Field,
  SitecoreContext,
  withSitecoreContext,
  LinkFieldValue,
  Image,
  ImageField,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { LinkRenderer } from '../LinkRenderer/LinkRenderer';
import './index.scss';
import { SubscriptionRoleFieldsProps } from '../Login/Login';
import { APIWebstoreContext } from '../../context/globalContext';
import { renderNavMenuItems } from '../../utils/subscriptionHelper';
import nextId from 'react-id-generator';

export type MenuLinkFieldProps = {
  Link: Field<LinkFieldValue>;
  Id?: Field<string>;
  Roles: Array<SubscriptionRoleFieldsProps>;
  'Desktop Image'?: ImageField;
};

export type MenuFieldsProps = {
  fields: MenuLinkFieldProps;
  displayName: string;
};
export type HeaderMenuProps = WithSitecoreContextProps & {
  fields: {
    items: Array<MenuFieldsProps>;
  };
  isCustom: Boolean;
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

export const HeaderMenu = ({
  fields,
  sitecoreContext,
  isCustom = false,
}: HeaderMenuProps): React.JSX.Element => {
  const { state } = useContext(APIWebstoreContext);

  if (fields) {
    const menuItems = renderNavMenuItems(fields.items, state);

    return (
      <div className={`headermenu ${isCustom ? 'custom' : 'default'}`}>
        <nav className="my-2 my-md-0 mr-md-3 nav-menu">
          {menuItems?.map((item: any) => {
            const hasImage = !!item?.fields['Desktop Image']?.value?.src;
            const link = item.fields.Link?.value?.href;

            return (
              <div className="menuItem" key={nextId()}>
                <div
                  className="navItemInner"
                  onClick={() => {
                    if (isCustom && link) {
                      window.location.href = link;
                    }
                  }}
                >
                  {isCustom && hasImage && (
                    <>
                      <Image className="navImage" field={item.fields['Desktop Image'].value} />
                      <div className="navTextWrapper">
                        <LinkRenderer fields={{ Link: item.fields.Link }} />
                      </div>
                    </>
                  )}

                  {isCustom && !hasImage && (
                    <>
                      <div className="navTextNoIcon">
                        <LinkRenderer fields={{ Link: item.fields.Link }} />
                      </div>
                    </>
                  )}

                  {!isCustom && <LinkRenderer fields={{ Link: item.fields.Link }} />}
                </div>
              </div>
            );
          })}
        </nav>
        <span className="verticalline"></span>
      </div>
    );
  } else if (!fields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }
  return <></>;
};

export default withSitecoreContext()(HeaderMenu);
